import { Box } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import NotificationModal from './NotificationModal';
import { useDispatch, useSelector } from 'react-redux';
import { EmptyDashboard } from './EmptyDashboard';
import {DataInstaDashboard} from './DataInstaDashboard';
import { setLoading } from '../../redux/features';
import EmptyInsta from './EmptyInsta';

export const InstaDashboardPage = (props: any) => {
  const profileData = props.profileData
  const { loading } = useSelector((state: any) => state.loader);
  const [open, setOpen] = React.useState(false);
  const [loader, setLoader] = useState(true)
  const dispatch = useDispatch();

  useEffect(() => {
    if (profileData !== undefined) {
      if (Object.keys(profileData).length > 0) {
        const getProfileData = async () => {
          setTimeout(() => {
            setLoader(false)

          }, 100);
        };
        getProfileData();
      } else {
        setTimeout(() => {
          setLoader(false)
        }, 200);
      }
    }
  }, [profileData]);

  return (
    <Box>
      <Box
        sx={{
         
          '& .MuiAppBar-root': {
            position: 'sticky',
            top: 0,
          },
          '& .MuiPaper-root': {
            pr: 'none',
          },
        }}
      >
        <DataInstaDashboard />
        {/* {!loader ? profileData?.channel_count === 0 ? <EmptyInsta /> : <DataInstaDashboard  /> : <></>} */}
      </Box>
      {/* <NotificationModal open={open} setOpen={setOpen} /> */}
    </Box>
  );
};

